import { MetadataSerialization, UserPortalProperties } from '@adaptiva/metadata/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';
import { BaseAuthoringPropertiesComponent } from '../base-authoring-component';

@Component({
	standalone: false,
	selector: 'ada-user-portal-properties',
	templateUrl: 'user-portal-properties.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush
})
export class UserPortalPropertiesComponent extends BaseAuthoringPropertiesComponent<UserPortalProperties> {

	public propertyConstructor: MetadataSerialization.Deserializable<UserPortalProperties> = UserPortalProperties;

}
